import React, { useEffect, useState, useCallback } from "react";
import style from "./area.module.css";

import ContentPasteSearchOutlinedIcon from "@mui/icons-material/ContentPasteSearchOutlined";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import logger from "../../../../utils/logger";

const normalize = (value) => String(value || "").trim().toLowerCase();

function Area({ areaInformations, validator }) {
  const [plot, setPlot] = useState("");
  const [hectar, setHectar] = useState("");
  const [plotError, setPlotError] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const getPlotsFromStorage = useCallback(() => {
    try {
      const storedPlots = localStorage.getItem("allPlots");
      if (!storedPlots) return [];

      const parsed = JSON.parse(storedPlots);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.dados)) return parsed.dados;
      if (parsed && typeof parsed.dados === "object") {
        return Object.values(parsed.dados)
          .filter((item) => Array.isArray(item))
          .flat();
      }
      if (parsed && typeof parsed === "object") {
        return Object.values(parsed)
          .filter((item) => Array.isArray(item))
          .flat();
      }
      return [];
    } catch (error) {
      logger.error("Erro ao carregar lista de talhões", error);
      return [];
    }
  }, []);

  const handleSelectPlot = useCallback((plotName) => {
    const region = localStorage.getItem("region");
    const plotsArray = getPlotsFromStorage();
    const matches = plotsArray.filter(
      (item) =>
        normalize(item?.plot) === normalize(plotName) &&
        (!region || normalize(item?.region) === normalize(region))
    );

    if (matches.length === 0) {
      setPlotError(`Talhão com o nome ${plotName} não existe.`);
      setHectar("");
      return;
    }

    setPlotError("");
    const selected = matches[0];
    setHectar(selected?.area || "");
    localStorage.setItem("register-plot-alternate", JSON.stringify(selected));
    setPlot(selected?.plot || plotName);
  }, [getPlotsFromStorage]);

  const handleChangePlot = (event) => {
    const value = event.target.value;
    setPlot(value);
    setPlotError("");

    const query = normalize(value);
    if (query.length < 2) {
      setSuggestions([]);
      return;
    }

    const region = localStorage.getItem("region");
    const plotsArray = getPlotsFromStorage();
    const uniquePlotNames = [
      ...new Set(
        plotsArray
          .filter((item) => !region || normalize(item?.region) === normalize(region))
          .map((item) => String(item?.plot || "").trim())
          .filter(Boolean)
      ),
    ];

    const filtered = uniquePlotNames
      .filter((name) => normalize(name).includes(query))
      .sort((a, b) => a.localeCompare(b));

    setSuggestions(filtered);
  };

  const handleBlurPlot = () => {
    if (!plot || !plot.trim()) return;
    handleSelectPlot(plot);
    setTimeout(() => setSuggestions([]), 120);
  };

  const handleChangeInformationsArea = useCallback(() => {
    // Só chamar areaInformations se plot tiver valor
    if (plot && plot.trim() !== "") {
      let informations = {
        plot,
        hectar,
      };
      areaInformations(informations);
    }
  }, [plot, hectar, areaInformations]);

  useEffect(() => {
    handleChangeInformationsArea();
  }, [handleChangeInformationsArea]);

  useEffect(() => {
    setPlot("");
    setHectar("");
    setPlotError("");
    setSuggestions([]);
  }, [validator]);

  return (
    <div className={style["card"]}>
     
      <div className={style["input"]}>
        <Box
          component="form"
          sx={{
            "& > :not(style)": { width: "100%" },
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-basic"
            label="Talhão"
            variant="standard"
            onChange={(value) => {
              handleChangePlot(value);
            }}
            onBlur={handleBlurPlot}
            value={plot}
            error={!!plotError}
            helperText={plotError}
            InputProps={{
              startAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    edge="start"
                  >
                    <ContentPasteSearchOutlinedIcon
                      style={{ color: "black" }}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {suggestions.length > 0 && (
            <div className={style["suggestions-list"]}>
              {suggestions.map((suggestion) => (
                <button
                  type="button"
                  key={suggestion}
                  className={style["suggestion-item"]}
                  onMouseDown={() => handleSelectPlot(suggestion)}
                >
                  {suggestion}
                </button>
              ))}
            </div>
          )}
        </Box>
      </div>

      {/* <div className={style["sector-inputs"]}>
        <input
          placeholder="ha"
          className={style["input-information"]}
          value={hectar}
          onChange={(value) => handleChangeHectar(value)}
          type="number"
        ></input>
      </div> */}
    </div>
  );
}

export default Area;

